module.exports = __webpack_public_path__ + "static/media/arrow_right.65dd2037.svg";